import PhoneFooter from './PhoneFooter';

export default PhoneFooter;
